// extracted by mini-css-extract-plugin
export default {"entry":"Y-Afj","input":"zp1FA"};